module.exports = __webpack_public_path__ + "media/images/icon__arrow-right@3x-a9692455f41918d35c7dee61f7f4703f.png";